export default "__VITE_ASSET__CTBEc_Z8__"